import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'modal-confirm',
  template: require('./modal-confirm.component.pug'),
  styles: [require('./modal-confirm.component.css').toString()],
})
export class ModalConfirmComponent implements OnInit {
  // Options to pass to the modal:
  onDelete: (onFailure: onSmartFailure) => void;
  title: string;
  public reason: Subject<any>;
  buttonTitle = 'Delete';
  bodyText = '';
  confirmText = 'Please confirm, there is no undo possible for this action.';

  // -------------------------------------------------------------------
  constructor(public bsModalRef: BsModalRef) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.reason = new Subject();
  }

  // -------------------------------------------------------------------
  onCancel() {
    this.bsModalRef.hide();
  }

  // -------------------------------------------------------------------
  delete(_data: any, _onsuccess: onSmartSuccess, onFailure: onSmartFailure) {
    this.onDelete(onFailure);
  }
}
